import { $api } from "@/shared/api";

import { isStatsPending, STATS_POLL_INTERVAL_MS } from "./statsPolling";

// Сводка игрока: вся история, ранг, герои, стороны игры и быстрые оценки последних матчей.
// Бэкенд отдаёт готовое из базы; пока первый быстрый разбор идёт — опрос раз в 5 секунд.
export const useStatsSummary = () =>
  $api.useQuery("get", "/api/stats/summary", undefined, {
    refetchInterval: ({ state }) =>
      isStatsPending(state.data, state.dataUpdateCount) ? STATS_POLL_INTERVAL_MS : false,
  });
